import { createContext, useContext } from 'react'

const MapDrawingContext = createContext(false)

export const MapDrawingProvider = MapDrawingContext.Provider

export const useIsDrawingActive = () => useContext(MapDrawingContext)
